<script setup lang="ts">

</script>

<template>
    <button type="button" class="text-mono-ps-100 hover:text-mono-white block p-3" aria-label="Search" title="Search">
        <svg class="search-icon w-5 h-5" fill="currentColor">
            <use xlink:href="#search-icon"></use>
        </svg>
    </button>
</template>

<style scoped>

</style>
